import { GriffelStyle } from "@fluentui/react-components";

export const Breakpoints = {
  extraSmall: (style: GriffelStyle): Record<string, GriffelStyle> => {
    return { "@media (max-width: 480px)": style };
  },
  small: (style: GriffelStyle): Record<string, GriffelStyle> => {
    return { "@media (max-width: 760px)": style };
  },
  medium: (style: GriffelStyle): Record<string, GriffelStyle> => {
    return { "@media (max-width: 1200px)": style };
  },
  large: (style: GriffelStyle): Record<string, GriffelStyle> => {
    return { "@media (max-width: 1550px)": style };
  },
  extraLarge: (style: GriffelStyle): Record<string, GriffelStyle> => {
    return { "@media (min-width: 1550px)": style };
  },
  extraExtraLarge: (style: GriffelStyle): Record<string, GriffelStyle> => {
    return { "@media (min-width: 1900px)": style };
  },
};
